
import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  toRaw,
  toRefs,
  watch,
} from "vue";
import { Form, Modal } from "ant-design-vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import * as CryptoJS from "crypto-js";
import { api } from "../../api/user";

export default defineComponent({
  components: {},
  props: {
    left: {
      type: Number,
      default: 0,
    },
  },
  emits: ["pwd"],
  setup(props, { emit }) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    // user box
    const avatars = [{ name: "企业", color: "rgba(24, 144, 255, 1)" }];
    const userType = 0;
    const username = ref<string>(store.getters.assnUser.username);
    const password = reactive({
      pwdShow: false,
      editPwd: () => {
        password.pwdShow = true;
      },
      pwdLoading: false,
      pwdValues: {
        old: "",
        new: "",
        rpt: "",
      },
      pwdRules: {
        old: [
          { required: true, message: "请输入密码" },
          { min: 4, message: "密码大于4位", trigger: "blur" },
          { max: 20, message: "密码小于20位", trigger: "blur" },
        ],
        new: [
          { required: true, message: "请输入新密码" },
          { min: 4, message: "密码大于4位", trigger: "blur" },
          { max: 20, message: "密码小于20位", trigger: "blur" },
        ],
        rpt: [
          { required: true, message: "请再次输入密码" },
          {
            asyncValidator: (rule: any, value: any, callback: any) => {
              if (value !== password.pwdValues.new) {
                callback("两次密码不一致");
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      pwdReset: ref(),
      pwdValidate: ref(),
      pwdValidateInfos: ref(),
    });
    const useForm = Form.useForm;
    const { resetFields, validate, validateInfos } = useForm(
      reactive(password.pwdValues),
      reactive(password.pwdRules)
    );
    password.pwdReset = resetFields;
    password.pwdValidate = validate;
    password.pwdValidateInfos = validateInfos;
    const pwd = () => {
      password
        .pwdValidate()
        .then(async () => {
          password.pwdLoading = true;
          const pwdData = toRaw(password.pwdValues);
          const params = {
            old: CryptoJS.HmacMD5(pwdData.old, username.value)
              .toString()
              .toUpperCase(),
            new: CryptoJS.HmacMD5(pwdData.new, username.value)
              .toString()
              .toUpperCase(),
            rpt: CryptoJS.HmacMD5(pwdData.rpt, username.value)
              .toString()
              .toUpperCase(),
          };
          const datas = await api("pwd", params);
          password.pwdLoading = false;
          if (datas.status === false) {
            Modal.error({
              centered: true,
              content: () => datas.data,
            });
          } else {
            password.pwdShow = false;
            Modal.success({
              centered: true,
              content: () => "密码修改成功",
            });
            password.pwdReset();
          }
        })
        .catch((err: any) => {
          console.log("form error", err);
        });
    };
    const logout = () => {
      Modal.confirm({
        centered: true,
        title: () => "确定退出登录?",
        async onOk() {
          store.commit("logout");
          Modal.destroyAll();
          setTimeout(() => {
            router.push({ name: "login" });
          }, 500);
        },
      });
    };
    // breadcrumbs
    const routes = ref<Record<any, any>>([]);
    const setBreadCrumbRoute = () => {
      routes.value = [{ path: "/", breadcrumbName: "首页" }];
      router.options.routes.forEach((val: any) => {
        if (val.name === route.name) {
          routes.value.push({ path: val.path, breadcrumbName: val.meta.title });
        } else {
          if (val.children !== undefined) {
            val.children.forEach((sval: any) => {
              if (sval.name === route.name) {
                routes.value.push(
                  { breadcrumbName: val.meta.title },
                  { path: sval.path, breadcrumbName: sval.meta.title }
                );
              }
            });
          }
        }
      });
    };
    watch(
      () => route.name,
      () => {
        setBreadCrumbRoute();
      }
    );
    onMounted(async () => {
      await router.isReady();
      setBreadCrumbRoute();
    });
    return {
      avatars,
      userType,
      username,
      ...toRefs(password),
      pwd,
      logout,
      routes,
    };
  },
});
